<template>
	<div v-if="loaded">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Client Information</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* required</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Client Name *</label>
							<md-input type="text" v-model="client.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Client Khmer Name *</label>
							<md-input type="text" v-model="client.name_khmer"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Gender *</label>
							<md-select placeholder="Gender *" v-model="client.gender">
								<md-option value="f">Female</md-option>
								<md-option value="m">Male</md-option>
								<md-option value="o">Other</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Date of Birth *</label>
							<md-input type="text" v-model="client.dob"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Client Phone *</label>
							<md-input type="text" v-model="client.phone"></md-input>
						</md-field>
					</div>

					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ID Card Number *</label>
							<md-input type="text" v-model="client.id_card"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Occupation *</label>
							<md-input type="text" v-model="client.occupation"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Address</label>
							<md-input type="text" v-model="client.address">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Client Note</label>
							<md-input type="text" v-model="client.note">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-size-100 file-image"
						style="text-align: center;">
						<div class="file-image-wrapper">
							<h6>ID Card Photo</h6>
							<div class="md-layout-item md-small-size-100 md-size-100" style="min-height: 150px;">
								<input type="file" ref="id_card" accept="image/*" style="display: none;"
									@change="processFile($event, 'id_card')">
								<img class="thumb-product" src="/id-card.png" v-if="String(client.image_url).length == 0">
								<img class="thumb-product" :src="client.image_url" v-if="String(client.image_url).length > 12">
								<img class="thumb-product" :src="config.getImageUrl(client.image_url)"
									v-if="String(client.image_url).length == 12">
							</div>

							<md-button class="md-primary" @click="openImage('id_card')"
								v-if="String(client.image_url).length == 0">Upload</md-button>
							<md-button class="md-primary" @click="removeImage()" v-else>Remove</md-button>
						</div>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Summary</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">Client Name</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name).length > 0">{{client.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Khmer Name</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name_khmer).length > 0">{{client.name_khmer}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Gender</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.gender).length > 0 && client.gender == 'm'">Male</span>
								<span v-else-if="String(client.gender).length > 0 && client.gender == 'f'">Female</span>
								<span v-else-if="String(client.gender).length > 0 && client.gender == 'o'">Other</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Date of Birth</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Occupation</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Phone</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ID Card</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Address</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.address).length > 0">{{client.address}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Note</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.note).length > 0">{{client.note}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateClient()">Update</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getClient();

		},
		data() {
			return {
				loaded: false,
				client: {
					valid: false,
					id: "",
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: "",
					id_card_image: "",
					image_url: ""
				}
			}
		},
		computed: {
			getImageUrl() {
				return this.client.image_url
			}
		},
		methods: {
			updateClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/update", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Client was update successfully.",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/clients");
					}
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.name_khmer).length > 0
					&& String(this.client.phone).length > 0 && String(this.client.gender).length > 0
					&& String(this.client.dob) && String(this.client.id_card) && String(this.client.occupation)
					&& String(this.client.image_url).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.client.image_url = data.body.data.id_card_url
					this.loaded = true;
				})
			},
			processFile(e, file) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				this.client.image_url = "/loading-image.gif";
				this.$forceUpdate();
				let formData = new FormData();

				formData.append("image_id", files[0], files[0].name);
				var self = this;
				this.$http.post(this.config.api + '/admin/file/upload', formData, {
				}).then(res => {
					if (res.body.status == 'success') {
						this.client.image_url = res.body.data.id
						this.$forceUpdate();
					} else {
						this.client.image_url = "";
					}
				})
			},
			openImage(id) {
				this.$refs[id].click();
				this.$forceUpdate();
			},
			removeImage() {
				this.client.image_url = "";
				this.$forceUpdate();
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Edit.vue